package com.wintermar.inspection.feature.presentation.template.landing.widget.item

import androidx.compose.foundation.layout.Column
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.component.datetime.util.DateTimeUtil
import com.wintermar.inspection.core.ui.widget.table_container.ItemTableContainer
import com.wintermar.inspection.feature.domain.model.template.InspectionTemplateModel
import com.wintermar.inspection.feature.util.template_status.TemplateStatusView

@Composable
fun TemplateLandingItemWide(
    data: InspectionTemplateModel,
    onClick: (templateId: String) -> Unit
) {
    ItemTableContainer(
        onClick = { onClick(data.id) }
    ) {
        TextBodySmall(text = data.name, modifier = Modifier.weight(1f))
        TextBodySmall(
            text = DateTimeUtil.getLocalSystemDisplayWithTime(
                data.publishedDate
            ), modifier = Modifier.weight(0.5f)
        )
        Column(
            modifier = Modifier.weight(0.5f)
        ) {
            TemplateStatusView(status = data.status)
        }
    }
}
